import React from "react";
import { Col, Button, Form, Row } from "react-bootstrap";
import { Formik } from "formik";
import classes from "../../WebsiteManagement/websiteManagement.module.css";

const AddRoomSet = (props) => {
 

  return (
    <div className={classes.Box}>
      <Formik
        initialValues={{}}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const newData = {
            numberOfAdults: values.numberOfAdults,
            numberOfChildren: values.numberOfChildren,
            roomSetId: 0,
            roomSetName: values.roomSetName,
          };
          const res = await fetch("https://api.zupptravel.com/api/v1/roomSet/addRoomSet", {
            method: "post",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newData),
          });

          const json = await res.json();
          if (json.success) {
            alert("Added Room Set!");
            // props.click();
            // window.location.reload();
          } else {
            alert("Error! Please try again later");
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formBasicNumberOfAduts" as={Row}>
              <Form.Label column sm="3">
                Room Set Name:
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="text"
                  placeholder="Enter Room Set Name"
                  name="roomSetName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.roomSetName}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group controlId="formBasicNumberOfAduts" as={Row}>
              <Form.Label column sm="3">
                Number of Adults:
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="number"
                  placeholder="Enter Number of Adults"
                  name="numberOfAdults"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.numberOfAdults}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group controlId="formBasicNumberOfChildren" as={Row}>
              <Form.Label column sm="3">
                Number of Children:
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="number"
                  placeholder="Enter Number of Children"
                  name="numberOfChildren"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.numberOfChildren}
                  required
                />
              </Col>
            </Form.Group>
            <center>
              <Button type="submit" variant="success">
                Save Room Set
              </Button>
            </center>
          </Form>
        )}
      </Formik>
      <hr />
    </div>
  );
};
export default AddRoomSet;
